import React from "react";
import {
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
} from "recharts";
import { SectionCard } from "../scraper";

const COLORS = ["#10b981", "#f43f5e"];

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    return (
        <div className="bg-white border border-gray-100 rounded-lg shadow-md px-3 py-2 text-xs">
            <span className="font-medium text-gray-700">
                {payload[0].name}: {payload[0].value.toLocaleString()}
            </span>
        </div>
    );
};

const renderCenterLabel = ({ cx, cy, success, total }) => (
    <g>
        <text
            x={cx}
            y={cy - 8}
            textAnchor="middle"
            className="fill-gray-800"
            style={{ fontSize: 22, fontWeight: 700, fill: "#1f2937" }}
        >
            {total > 0 ? `${Math.round((success / total) * 100)}%` : "—"}
        </text>
        <text
            x={cx}
            y={cy + 12}
            textAnchor="middle"
            style={{ fontSize: 11, fill: "#9ca3af" }}
        >
            success rate
        </text>
    </g>
);

const SuccessFailureChart = ({ success, failed }) => {
    const total = success + failed;
    const data = [
        { name: "Success", value: success },
        { name: "Failed", value: failed },
    ];

    return (
        <SectionCard title="Success vs Failure">
            {/* Summary pills */}
            <div className="flex gap-3 mb-4">
                <div className="flex-1 rounded-lg bg-emerald-50 border border-emerald-100 px-3 py-2 text-center">
                    <p className="text-xs text-emerald-600 font-medium">Delivered</p>
                    <p className="text-xl font-bold text-emerald-700 mt-0.5">
                        {success?.toLocaleString()}
                    </p>
                </div>
                <div className="flex-1 rounded-lg bg-rose-50 border border-rose-100 px-3 py-2 text-center">
                    <p className="text-xs text-rose-500 font-medium">Failed</p>
                    <p className="text-xl font-bold text-rose-600 mt-0.5">
                        {failed?.toLocaleString()}
                    </p>
                </div>
            </div>

            <div className="h-64">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            innerRadius={70}
                            outerRadius={100}
                            paddingAngle={3}
                            label={false}
                            labelLine={false}
                        >
                            {data.map((_, index) => (
                                <Cell key={index} fill={COLORS[index]} />
                            ))}
                        </Pie>
                        {/* Render center label manually via customized label prop on Pie */}
                        <Pie
                            data={[{ value: 1 }]}
                            dataKey="value"
                            innerRadius={0}
                            outerRadius={0}
                            label={() => renderCenterLabel({
                                cx: 0, cy: 0, success, total
                            })}
                            labelLine={false}
                            isAnimationActive={false}
                            fill="transparent"
                            stroke="none"
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend
                            wrapperStyle={{ fontSize: 12 }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </SectionCard>
    );
};

export default SuccessFailureChart;